// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__2WDKo","title":"AfterImages45_title__3959r","images":"AfterImages45_images__3Kju8"};